// extracted by mini-css-extract-plugin
module.exports = {"header":"app-module--header--1LsEp","headerInner":"app-module--headerInner--2N3Wd","siteIcon":"app-module--siteIcon--1wovs","siteTitle":"app-module--siteTitle--175sk"};